import { http } from '@/http/axios.js'
export function getIndexStatAPI(params) {
  return http({
    url: '/api/store/home/data',
    method: 'get',
    params
  })
}
